import {cast, Instance, types} from 'mobx-state-tree';
import {ResetModel} from 'core/models';
import {IJournalPoint} from 'core/interfaces';

const Journal = types
  .compose(
    ResetModel,
    types.model('Journal', {
      isOpen: false,
      points: types.optional(types.array(types.frozen<IJournalPoint>()), [])
    })
  )
  .actions((self) => ({
    toggleOpen(): void {
      self.isOpen = !self.isOpen;
    },
    close(): void {
      self.isOpen = false;
    },
    setPoints(points: IJournalPoint[]): void {
      self.points = cast(points);
    },
    clearPoints(): void {
      self.points = cast([]);
    }
  }))
  .views(() => ({}));

export type TJournalModel = Instance<typeof Journal>;

export {Journal};
